module.exports = __webpack_public_path__ + "assets/img/19_856_big.bc310b49.jpg";